import { useFetchPrivacy } from "@apac/hooks";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Page } from "@b2bportal/core-ui";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { CallState } from "@hopper-b2b/types";
import { LazyLoading, PageHeader } from "@tenant/ui";
import styles from "./styles.module.scss";

export const PrivacyPolicyPage = () => {
  const { data, status } = useFetchPrivacy();
  const [block, cn] = useModuleBEM(styles, "PrivacyPolicyPage");
  return (
    <Page
      header={<PageHeader hideSummary hidePoints={true} />}
      className={block}
    >
      {status === CallState.InProcess && (
        <LazyLoading className={cn("loading")} />
      )}
      {status === CallState.Success && data ? (
        <div className={cn("contentWrapper")}>
          <h1 className={cn("header")}>{data?.headline}</h1>
          {documentToReactComponents(data?.content1?.json, {
            renderNode: {
              [BLOCKS.TABLE]: (_, children) => (
                <div className={cn("tableWrapper")}>
                  <table>
                    <tbody>{children}</tbody>
                  </table>
                </div>
              ),
            },
          })}
        </div>
      ) : null}
    </Page>
  );
};
